import { checkValue } from 'src/components/common/helper';

const useScrollArrowFunction = (heroClassName: string, headerClassName: string, heroAnchorLink?: string) => {
  const handleScroll = () => {
    const heroBanner = document.querySelector(`.${heroClassName}`);
    const headerOffsetHeight = document.querySelector<HTMLElement>(`.${headerClassName}`)?.offsetHeight;
    const scrollToModule = document.getElementById(`${heroAnchorLink}`);

    if (checkValue(heroBanner) && checkValue(headerOffsetHeight)) {
      let top = document.body.getBoundingClientRect().top - headerOffsetHeight;

      if (heroBanner?.nextElementSibling) {
        top =
          heroBanner.nextElementSibling.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          headerOffsetHeight;
      } else if (heroBanner?.parentElement?.nextElementSibling) {
        top =
          heroBanner.parentElement.nextElementSibling.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          headerOffsetHeight;
      }

      if (checkValue(scrollToModule) && checkValue(heroAnchorLink)) {
        top =
          scrollToModule.getBoundingClientRect().top - document.body.getBoundingClientRect().top - headerOffsetHeight;
      }

      setTimeout(() => {
        window.scrollTo({
          behavior: 'smooth',
          top,
        });
      }, 400);
    }
  };

  return { handleScroll };
};

export default useScrollArrowFunction;
